import { render, staticRenderFns } from "./AdminExternalBrokerView.vue?vue&type=template&id=95a4fd5a"
import script from "./AdminExternalBrokerView.vue?vue&type=script&lang=js"
export * from "./AdminExternalBrokerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports